import { MigrationStatusType } from 'OpsCenter/merchants/settings/migration-status-type';

export default function MerchantPortalConfigurationController(
  $scope,
  $rootScope,
  $stateParams,
  $state,
  $timeout,
  sessionService,
  DestinationService,
  countryService,
  merchantService,
  NotificationService,
  merchantCategoriesService,
  UtilService,
  searchTagsService,
  MERCHANT_PRODUCTS,
  DESTINATION_TYPES,
  SEARCH_TAGS_TYPES,
  MERCHANT_CONSTANTS,
  NgMap,
  slugifyService,
  uirouterMigrationService,
  googleMapsHelper,
) {
  const vm = this;

  vm.merchantPortalConfigurationForm = 'merchantPortalConfigurationForm';
  vm.googleMapsUrl = googleMapsHelper.getApiUrl();
  vm.merchantId = $stateParams.merchantId;
  vm.merchant = $stateParams.merchant;
  vm.merchantMigrationCurrentStatus = $stateParams.externalPartnerSources;
  vm.isLoading = false;
  vm.isContentEditor = sessionService.hasPermission(['EDITORIAL']);
  vm.isMerchantManager = sessionService.hasRole(['MERCHANT_MANAGER']) || sessionService.hasRole(['SUPER_ADMIN']);
  vm.isQuandooManager = sessionService.hasRole(['QUANDOO_MANAGER']) || sessionService.hasRole(['SUPER_ADMIN']);
  vm.coreProductType = null;
  vm.isQRBMerchant = false;
  vm.isExternalPartner = false;
  vm.additionalProductType = {};
  vm.merchantProducts = MERCHANT_PRODUCTS;
  vm.merchantCoreProducts = [
    MERCHANT_PRODUCTS.BOOK,
    MERCHANT_PRODUCTS.QRB,
    MERCHANT_PRODUCTS.FREE_PLUS,
    MERCHANT_PRODUCTS.MERCHANT_CENTER_BASIC,
    MERCHANT_PRODUCTS.PROFESSIONAL_WEB,
    MERCHANT_PRODUCTS.PREMIUM_MERCHANT,
    MERCHANT_PRODUCTS.EXTERNAL_PARTNER
  ];
  vm.merchantCoreProductsSpecialTypes = [
    MERCHANT_PRODUCTS.LISTING_NON_PARTNER_RESTAURANT,
    MERCHANT_PRODUCTS.PROSPECT,
    MERCHANT_PRODUCTS.EXTERNAL_PARTNER,
  ];
  vm.countryId = null;
  vm.regionId = null;
  vm.cityId = null;
  vm.districtId = null;
  vm.browserUrlInputIsDisable = true;
  vm.merchantTags = [];
  vm.priceTags = [];
  vm.merchantPriceTag = {};
  vm.semBusinessNameCharLimit = MERCHANT_CONSTANTS.SEM_BUSINESS_NAME_LIMIT;
  vm.merchantMigrationCurrentStatus = [];
  vm.isMerchantMigrationCurrentInProgress = false;

  vm.options = {
    countries: [],
    regions: [],
    cities: [],
    districts: [],
  };

  vm.PRICES_TAGS_NAMES = SEARCH_TAGS_TYPES.PRICES_TAGS_NAMES;
  //TODO manage PriceTags by id once attribute to tags migration done

  vm.init = init;
  vm.getRegions = getRegions;
  vm.getCities = getCities;
  vm.getDistricts = getDistricts;
  vm.updateDestinationId = updateDestinationId;
  vm.updateCityField = updateCityField;
  vm.save = save;
  vm.mapMarkerDragEnd = mapMarkerDragEnd;
  vm.slugify = slugify;
  vm.showOfflineAlert = showOfflineAlert;
  vm.updateCuisineTags = updateCuisineTags;
  vm.updateMerchantPriceTag = updateMerchantPriceTag;
  vm.onSemBusinessNameChange = onSemBusinessNameChange;
  vm.triggerReindex = triggerReindex;
  vm.cancelAllReservations = cancelAllReservations;
  vm.goTo = goTo;
  vm.switchToQrb = switchToQrb;
  vm.migrationStatusType = MigrationStatusType;

  let beenInitialised = false;
  const listener = $scope.$on('merchant.tab.configuration.selected', vm.init);

  $timeout(function ensureInitRuns() {
    if (!beenInitialised && $state.params.tab === 'configuration') {
      init();
    }
  }, 1000);

  function init(_, data) {
    beenInitialised = true;
    listener();
    getMerchant();
    getCountries();
    getMerchantTags();
    vm.merchantMigrationCurrentStatus = data.externalPartnerSources;
    vm.isMerchantMigrationCurrentInProgress =
      vm.merchantMigrationCurrentStatus[0].migrationStatus === 'STARTED' ||
      vm.merchantMigrationCurrentStatus[0].migrationStatus === 'SUCCEEDED';
  }

  function getCountries() {
    countryService.getAllCountries().then(function(res) {
      if (res && res.data) {
        vm.options.countries = res.data;
      }
    });
  }

  function getRegions() {
    let params;
    const config = {
      destination_type: DESTINATION_TYPES.REGION.name,
      status: 'active',
    };
    if (!vm.countryId) {
      return;
    }
    params = UtilService.generateSearchUrl(config);
    DestinationService.getDestinationChildren(vm.countryId, params).then(function(res) {
      vm.options.regions = res.data;
      vm.options.cities = [];
      vm.options.districts = [];
      vm.destinationId = null;
    });
  }

  function getCities() {
    let params;
    const config = {
      destination_type: DESTINATION_TYPES.CITY.name,
      status: 'active',
    };
    if (!vm.regionId) {
      return;
    }
    params = UtilService.generateSearchUrl(config);
    DestinationService.getDestinationChildren(vm.regionId, params).then(function(res) {
      vm.options.cities = res.data;
      vm.options.districts = [];
      vm.destinationId = null;
    });
  }

  function getDistricts() {
    let params;
    const config = {
      destination_type: DESTINATION_TYPES.DISTRICT.name,
      status: 'active',
    };
    if (!vm.cityId) {
      return;
    }
    params = UtilService.generateSearchUrl(config);
    DestinationService.getDestinationChildren(vm.cityId, params).then(function(res) {
      vm.options.districts = res.data;
    });
  }

  function getMerchant() {
    if (!vm.merchant || !vm.merchant.id === !parseInt(vm.merchantId, 10) /* merchant id can be a string */) {
      const bookSettingAttributeId = 1092;

      Promise.all([
        merchantService.getMerchantById(vm.merchantId),
        merchantService.getMerchantSetting(vm.merchantId, bookSettingAttributeId),
      ])
        .then(function(response) {
          const res = response.reduce((acc, r) => {
            const settings = (r && r.data && r.data.settings) ? r.data.settings : [];
            return Object.assign(acc, r.data, { settings });
          }, {});

          vm.merchant = res;
          setMerchant();
          NotificationService.success('Merchant retrieved');
        })
        .catch(function() {
          NotificationService.error('Invalid merchant id');
        })
        .finally(function() {
          vm.isLoading = false;
        });
    } else {
      setMerchant();
      vm.isLoading = false;
    }
  }

  function setMerchant() {
    vm.merchant.emails = angular.isArray(vm.merchant.emails) ? vm.merchant.emails.join(',') : '';
    vm.normalisedBrowserUrl = normalizeBrowserUrl(vm.merchant.browserUrl);
    assignDestinations();
    assignProductIds();
  }

  function slugify() {
    vm.normalisedBrowserUrl = slugifyService.slugify(vm.normalisedBrowserUrl);
  }

  function normalizeBrowserUrl(browserUrl) {
    return browserUrl.replace(/-\d+$/g, '');
  }

  function switchToQrb() {
    if (vm.isQRBMerchant) return;
    if (window.confirm(`This is a one-way operation and cannot be undone.\n\nIf you save these changes, ${vm.merchant.semBusinessName} will be permanently configured as a QfR merchant.`)) {
      vm.coreProductType = MERCHANT_PRODUCTS.QRB;
    } else {
      vm.coreProductType = MERCHANT_PRODUCTS.PROSPECT;
      vm.additionalProductType = {};
      document.querySelectorAll('[data-qa=merchantConfigurationProductQRB]')[0].checked = false;
    }
  }

  function assignProductIds() {
    const allProducts = vm.merchantCoreProducts.concat(vm.merchantCoreProductsSpecialTypes);
    angular.forEach(allProducts, function(productId) {
      if (vm.merchant.productIds.indexOf(productId) !== -1) {
        vm.coreProductType = productId;
      }
    });
    const { QRB, EXTERNAL_PARTNER } = vm.merchantProducts;
    vm.isQRBMerchant = vm.merchant.productIds.includes(QRB);
    vm.isExternalPartner = vm.merchant.productIds.includes(EXTERNAL_PARTNER);
    vm.additionalProductType = {
      listingPartner: vm.merchant.productIds.indexOf(vm.merchantProducts.LISTING_PARTNER_RESTAURANT) !== -1,
      bookingWidget: vm.merchant.productIds.indexOf(vm.merchantProducts.BOOKING_WIDGET) !== -1,
      bookingMessage: vm.merchant.productIds.indexOf(vm.merchantProducts.BOOKING_MESSAGE) !== -1,
      bookMVP: vm.merchant.settings && vm.merchant.settings.length > 0 && parseInt(vm.merchant.settings[0].value) === 1,
    };
  }

  function assignDestinations() {
    let params;
    const config = {
      destination_type: '',
      status: 'active',
    };
    vm.countryId = vm.merchant.destinationTree[1] ? vm.merchant.destinationTree[1].id : vm.merchant.destinationId;
    vm.regionId = vm.merchant.destinationTree[2] ? vm.merchant.destinationTree[2].id : null;

    DestinationService.getDestinationById(vm.merchant.destinationId, { ignoreStatus: 404 }).then(function(res) {
      switch (res.data.destinationType.id) {
        case DESTINATION_TYPES.CITY.id:
          vm.cityId = vm.merchant.destinationId;
          break;
        case DESTINATION_TYPES.DISTRICT.id:
          vm.cityId = vm.merchant.destinationTree[3] ? vm.merchant.destinationTree[3].id : null;
          vm.districtId = vm.merchant.destinationId;
          break;
      }
      config.destination_type = DESTINATION_TYPES.REGION.name;
      params = UtilService.generateSearchUrl(config);
      DestinationService.getDestinationChildren(vm.countryId, params).then(function(res) {
        vm.options.regions = res.data;
      });

      if (vm.cityId) {
        config.destination_type = DESTINATION_TYPES.CITY.name;
        params = UtilService.generateSearchUrl(config);
        DestinationService.getDestinationChildren(vm.regionId, params).then(function(res) {
          vm.options.cities = res.data;
        });
      }

      if (vm.districtId) {
        config.destination_type = DESTINATION_TYPES.DISTRICT.name;
        params = UtilService.generateSearchUrl(config);
        DestinationService.getDestinationChildren(vm.cityId, params).then(function(res) {
          vm.options.districts = res.data;
        });
      }
    });
  }

  function updateDestinationId() {
    if (vm.options.districts.length) {
      vm.merchant.destinationId = vm.districtId;
    } else {
      vm.merchant.destinationId = vm.cityId;
    }
  }

  function updateCityField() {
    vm.merchant.address = vm.merchant.address || {};
    if (vm.cityId) {
      angular.forEach(vm.options.cities, function(value) {
        if (value.id === vm.cityId) {
          vm.merchant.address.city = value.name;
        }
      });
    } else {
      vm.merchant.address.city = '';
    }
  }

  function getSelectedProductIds() {
    const selectedProductIds = [],
      isCoreProduct = vm.merchantCoreProducts.indexOf(vm.coreProductType) !== -1,
      isSpecialProduct = vm.merchantCoreProductsSpecialTypes.indexOf(vm.coreProductType) !== -1;
    let isFreePlus = vm.coreProductType === vm.merchantProducts.FREE_PLUS;

    if (vm.coreProductType) {
      selectedProductIds.push(vm.coreProductType);
    }
    if (isCoreProduct && vm.additionalProductType.listingPartner) {
      selectedProductIds.push(vm.merchantProducts.LISTING_PARTNER_RESTAURANT);
    }
    if (isCoreProduct && vm.additionalProductType.bookingWidget) {
      selectedProductIds.push(vm.merchantProducts.BOOKING_WIDGET);
    }
    if (isSpecialProduct && vm.additionalProductType.bookingMessage) {
      selectedProductIds.push(vm.merchantProducts.BOOKING_MESSAGE);
    }
    return selectedProductIds;
  }

  function getMerchantTags() {
    searchTagsService.getMerchantTags(vm.merchantId).then(res => {
      vm.merchantTags = res.data.searchTags;
      vm.cuisineTags = vm.merchantTags.filter(tag => tag.tagType === SEARCH_TAGS_TYPES.CUISINE);
      checkIfMainCuisineSelected();
      getAndSetPricesTags();
    });
  }

  function getAndSetPricesTags() {
    searchTagsService.getAllTags().then(res => {
      if (res.data) {
        vm.merchantPriceTag = vm.merchantTags.find(tag => tag.tagType === SEARCH_TAGS_TYPES.PRICE);
        vm.priceTags = res.data.searchTags.filter(tag => tag.tagType === SEARCH_TAGS_TYPES.PRICE);
      }
    });
  }

  /**
   * @param tags selected tags received from the cuisinesTags.component
   */
  function updateCuisineTags(tags) {
    vm.cuisineTags = tags;
    vm.merchantTags = vm.merchantTags.filter(tag => tag.tagType !== SEARCH_TAGS_TYPES.CUISINE).concat(vm.cuisineTags);
    checkIfMainCuisineSelected();
  }

  function checkIfMainCuisineSelected() {
    vm.isMainCuisineTagSelected = vm.merchantTags.find(tag => tag.primary);
  }

  function updateMerchantPriceTag(tagName) {
    vm.merchantPriceTag = vm.priceTags.find(tag => tag.name === tagName);

    const tagPriceIndex = vm.merchantTags.findIndex(tag => tag.tagType === SEARCH_TAGS_TYPES.PRICE);
    const newMerchantTags = angular.copy(vm.merchantTags);

    if (tagPriceIndex > -1) {
      newMerchantTags[tagPriceIndex] = vm.merchantPriceTag;
    } else {
      newMerchantTags.push(vm.merchantPriceTag);
    }

    vm.merchantTags = newMerchantTags;
  }

  function secureBrowserUrlForSave() {
    let merchantUrlInputGotId = vm.normalisedBrowserUrl.endsWith(vm.merchantId);
    const lastLetter = vm.normalisedBrowserUrl.slice(-1);
    const dash = '-';

    if (lastLetter === dash) {
      vm.normalisedBrowserUrl.slice(0, -1);
    } else if (!merchantUrlInputGotId) {
      vm.merchant.browserUrl = vm.normalisedBrowserUrl + dash + vm.merchantId;
    }
  }

  function save() {
    if (vm.isLoading || !vm.merchant) {
      return;
    }

    vm.merchantPortalConfigurationForm.$setDirty();

    if (vm.merchantPortalConfigurationForm.$invalid || !vm.isMainCuisineTagSelected || !vm.merchantPriceTag.id) {
      return;
    }

    vm.isLoading = true;
    vm.merchant.productIds = getSelectedProductIds();
    secureBrowserUrlForSave();

    // AQUI-759 Patches merchant updates being rejected due to empty categories array.
    if (!vm.merchant.categories.length) {
      vm.merchant.categories.push(1); // Eat & Drink default category
    }

    const merchant = Object.assign({}, vm.merchant);
    merchant.emails = merchant.emails.split(',').map(email => email.trim());

    merchantService
      .updateMerchant(vm.merchantId, merchant)
      .then(function(res) {
        if (res && res.data) {
          vm.merchant = res.data;
          updateTags();
          setMerchant();
        }
        $rootScope.$broadcast('merchant.configuration.updated', { merchant: vm.merchant });
        NotificationService.success('Merchant saved successfully');
      })
      .catch(function(res) {
        const error = angular.isArray(res.data.errors) ? res.data.errors.shift() : res.data.errors,
          errorMessage = error.message ? error.message : 'Merchant saved failed';
        NotificationService.error(errorMessage);
      })
      .finally(function() {
        vm.isLoading = false;
        vm.browserUrlInputIsDisable = true;
      });
  }

  function updateTags() {
    vm.isLoading = true;
    searchTagsService
      .updateMerchantTags(vm.merchantId, vm.merchantTags)
      .catch(() => {
        NotificationService.error('An error happened during tags save.');
      })
      .finally((vm.isLoading = false));
  }

  function mapMarkerDragEnd(e) {
    googleMapsHelper.setLatLng(e, vm.merchant);
  }

  function showOfflineAlert() {
    window.alert(`
    Please be careful when editing merchant product selections.

    Please only select this option if the merchant has specifically requested it!

    Otherwise use 'Non Partner (Listed Only)
    `);
  }

  function triggerReindex() {
    vm.isLoading = true;
    merchantService
      .triggerReindex(vm.merchantId)
      .then(() => NotificationService.success('Triggered availability reindex'))
      .catch(() => NotificationService.error('Reindex trigger failed'))
      .finally(() => (vm.isLoading = false));
  }

  function cancelAllReservations() {
    if (!window.confirm(`Are you sure you want to cancel ALL reservations for merchant ${vm.merchantId}`)) {
      return;
    }
    const promptAnswer = window.prompt(`Please type the merchant id to confirm the operation`);
    if (!promptAnswer || !(promptAnswer.trim() === vm.merchantId)) {
      NotificationService.error(`Incorrect id entered: ${promptAnswer}`);
      return;
    }

    vm.isLoading = true;
    merchantService
      .cancelAllReservations(vm.merchantId)
      .then(() => NotificationService.success('Canceled all reservations'))
      .catch(res => {
        let errorMessage = '';
        if (res.data && res.data.errors) {
          errorMessage = res.data.errors.shift[0].message;
        }
        NotificationService.error(`Failed to cancel all reservations ${errorMessage}`);
      })
      .finally(() => (vm.isLoading = false));
  }

  function onSemBusinessNameChange(semBusinessName) {
    vm.merchant.semBusinessName = semBusinessName;
    vm.merchantPortalConfigurationForm.$setDirty();
  }

  function goTo(state, params) {
    uirouterMigrationService.goTo(state, params);
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/merchant.portal-configuration.controller.js